import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
} from "recharts";

const colors = [
  "#8B5CF6",
  "#EC4899",
  "#06B6D4",
  "#22C55E",
  "#F59E0B",
  "#EF4444",
  "#6366F1",
];

export default function IQDaysBarGraph({ history = [] }) {
  const data = useMemo(() => {
    const order = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const counts = {
      Sun: 0,
      Mon: 0,
      Tue: 0,
      Wed: 0,
      Thu: 0,
      Fri: 0,
      Sat: 0,
    };

    history.forEach((h) => {
      const day = new Date(h.confirmedAt).toLocaleDateString("en-US", {
        weekday: "short",
      });
      counts[day]++;
    });

    return order.map((d) => ({
      day: d,
      plays: counts[d],
    }));
  }, [history]);

  return (
    <div className="bg-[#17152b] rounded-2xl border border-violet-500/30 p-3">

      <div className="text-center text-xs font-bold text-cyan-300 mb-3">
        🎮 Weekly Play Activity
      </div>

      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data}>
          <XAxis
            dataKey="day"
            tick={{ fill: "#ffffff", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis
            allowDecimals={false}
            tick={{ fill: "#ffffff", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              background: "#18122B",
              border: "1px solid #7C3AED",
              color: "#fff",
            }}
          />

          <Bar
            dataKey="plays"
            radius={[8, 8, 0, 0]}
          >
            {data.map((e, i) => (
              <Cell
                key={i}
                fill={colors[i]}
              />
            ))}
          </Bar>

        </BarChart>
      </ResponsiveContainer>

    </div>
  );
}